import { APP_ROUTES } from '@/lib/constants'

function getAppUrl() {
  const configured = process.env.NEXT_PUBLIC_APP_URL?.trim()
  if (configured) {
    return configured
  }

  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin
  }

  return 'http://127.0.0.1:3000'
}
const API_BASE_PATH = process.env.NEXT_PUBLIC_SUPERTOKENS_API_BASE_PATH ?? '/api/st-auth'
const WEBSITE_BASE_PATH = process.env.NEXT_PUBLIC_SUPERTOKENS_WEBSITE_BASE_PATH ?? '/auth'

export function getSuperTokensAppInfo() {
  const appUrl = getAppUrl()
  return {
    appName: 'askjyotish',
    apiDomain: appUrl,
    websiteDomain: appUrl,
    apiBasePath: API_BASE_PATH,
    websiteBasePath: WEBSITE_BASE_PATH,
  }
}

export function getAuthRoute() {
  return WEBSITE_BASE_PATH
}

export function getSuccessRedirectPath() {
  return APP_ROUTES.login
}
